import React, { useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { AppContext } from '@prisjakt/ui-app-context';
import Menu from '@prisjakt/ui-menu';
import MenuItem from '@prisjakt/ui-menu/src/components/menu-item';
import { Grow, Position } from '@prisjakt/ui-menu/src/types';

import { AppState } from '../../../reducers';
import { logoutRequest } from '../actions';
import listActions from '../../sidebar/actions/lists';

import * as S from './styles';

type OwnProps = {
  position: Position;
  grow: Grow;
  toggleElement: React.ReactElement;
  toggleElementStyles?: {};
  toggleElementActiveStyles?: {};
};

type StateProps = {
  isAuthenticated: boolean;
};

type DispatchProps = {
  dispatchLogoutRequest: (message: string) => void;
  closeLists: () => void;
  selectList: (id: number | null) => void;
};

type Props = OwnProps & DispatchProps & StateProps;

const AccountMenu = ({
  isAuthenticated = false,
  dispatchLogoutRequest,
  position,
  grow,
  toggleElement,
  toggleElementStyles,
  toggleElementActiveStyles,
  closeLists,
  selectList,
}: Props) => {
  const { t } = useContext(AppContext);

  const onLogout = useCallback(() => {
    selectList(null);
    closeLists();
    dispatchLogoutRequest(t('account', 'logout.successful'));
  }, [selectList, closeLists, dispatchLogoutRequest, t]);

  return (
    <>
      <Menu
        position={position}
        grow={grow}
        width="200px"
        toggleElement={toggleElement}
        toggleElementStyles={toggleElementStyles}
        toggleElementActiveStyles={toggleElementActiveStyles}
        closeOnClick
      >
        {!isAuthenticated ? (
          <S.Buttons>
            <S.AccountButton color="primary" component={<Link to="/login" />}>
              {t('account', 'menu.not-logged-in-button')}
            </S.AccountButton>

            <S.AccountButton
              color="primary"
              variant="outlined"
              component={<Link to="/signup" />}
            >
              {t('account', 'signup.submit-button')}
            </S.AccountButton>
          </S.Buttons>
        ) : (
          <div>
            <MenuItem href="/account/profile">
              {t('account', 'profile.title')}
            </MenuItem>
            <MenuItem href="/account/profile/settings">
              {t('account', 'menu.settings')}
            </MenuItem>

            <S.Buttons>
              <S.AccountButton
                color="secondary"
                variant="outlined"
                onClick={onLogout}
              >
                {t('account', 'menu.logout-button')}
              </S.AccountButton>
            </S.Buttons>
          </div>
        )}
      </Menu>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.areas.account.isAuthenticated,
});

const dispatchActions = {
  dispatchLogoutRequest: logoutRequest,
  closeLists: listActions.closeLists,
  selectList: listActions.selectList,
};

export default connect(mapStateToProps, dispatchActions)(AccountMenu);
